import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AttributeEnumValue  {
    _originalTypeClassName = "zERP.BO.AttributeEnumValue";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AttributeEnumValue.translate = translateService;
}
this.Id = null;
this.Description = null;
this.strValue = null;
this.checkValue = false;
this.bValue = false;
this.dtValue = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Description:any;
strValue:any;
checkValue:any;
bValue:any;
dtValue:any;
Attributes:any;
TempEntityFieldDTO:any;
ForeignAttribute:any;
static setAttributes = ($this, value) => {
var oldValue = $this.Attributes;
$this.Attributes = value;
if (value != null) {
if (oldValue != null) {
Domain.Attribute.removeAttributeEnumValue(oldValue, $this);
}
Domain.Attribute.addAttributeEnumValue(value, $this);
}
}
static setTempEntityFieldDTO = ($this, value) => {
var oldValue = $this.TempEntityFieldDTO;
$this.TempEntityFieldDTO = value;
if (value != null) {
}
}
static setForeignAttribute = ($this, value) => {
var oldValue = $this.ForeignAttribute;
$this.ForeignAttribute = value;
if (value != null) {
if (oldValue != null) {
Domain.ForeignAttribute.removeClsAttributeEnumValue(oldValue, $this);
}
Domain.ForeignAttribute.addClsAttributeEnumValue(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}